var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "formAddCampaign",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                },
              },
              [
                _vm.mainLoading
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-center mb-1" },
                      [
                        _c("b-spinner", {
                          staticStyle: { width: "3rem", height: "3rem" },
                          attrs: {
                            variant: "success",
                            label: "Spinning",
                            block: "",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.mainLoading
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Campaign Id",
                                  "label-for": "campaign_id",
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Campaign Id",
                                    readonly: "",
                                    name: "campaign_id",
                                  },
                                  model: {
                                    value: _vm.emailId.id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.emailId, "id", $$v)
                                    },
                                    expression: "emailId.id",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Campaign Name",
                                  "label-for": "campaign_name",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "campaign name",
                                    vid: "Campaign Name",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Campaign Name",
                                                name: "campaign_name",
                                              },
                                              model: {
                                                value: _vm.emailId.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.emailId,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "emailId.name",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Start Date",
                                  "label-for": "start_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "start date",
                                    vid: "Start Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "start_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                "initial-date": "2024-06-16",
                                              },
                                              model: {
                                                value: _vm.emailId.startDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.emailId,
                                                    "startDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "emailId.startDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "End Date",
                                  "label-for": "end_date",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "end date",
                                    vid: "End Date",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-datepicker", {
                                              attrs: {
                                                id: "end_date",
                                                placeholder: "Choose a date",
                                                local: "en",
                                                "initial-date": "2024-06-16",
                                              },
                                              model: {
                                                value: _vm.emailId.endDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.emailId,
                                                    "endDate",
                                                    $$v
                                                  )
                                                },
                                                expression: "emailId.endDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Email Template",
                                  "label-for": "email_template",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email template",
                                    vid: "Email Template",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                options: _vm.emailtemplatelist,
                                              },
                                              on: {
                                                change: _vm.selectTemplate,
                                              },
                                              model: {
                                                value: _vm.selectedTemplateId,
                                                callback: function ($$v) {
                                                  _vm.selectedTemplateId = $$v
                                                },
                                                expression:
                                                  "selectedTemplateId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Subject",
                                  "label-for": "subject",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "subject",
                                    vid: "Subject",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                placeholder: "Subject",
                                                name: "subject",
                                              },
                                              model: {
                                                value: _vm.emailId.subject,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.emailId,
                                                    "subject",
                                                    $$v
                                                  )
                                                },
                                                expression: "emailId.subject",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Segment",
                                  "label-for": "segment",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "segment",
                                    vid: "Segment",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              attrs: {
                                                options: _vm.segmentOptions,
                                                multiple: "",
                                                label: "itemTitle",
                                              },
                                              model: {
                                                value: _vm.selectedSegments,
                                                callback: function ($$v) {
                                                  _vm.selectedSegments = $$v
                                                },
                                                expression: "selectedSegments",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Status",
                                  "label-for": "status",
                                },
                              },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.statusOptions,
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.emailId.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.emailId, "status", $$v)
                                    },
                                    expression: "emailId.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "6" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "SMTP Setting",
                                  "label-for": "email_smtp",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "SMPT setting",
                                    vid: "SMPT Setting",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                options: _vm.smtp,
                                              },
                                              model: {
                                                value:
                                                  _vm.emailId.smtpSettingId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.emailId,
                                                    "smtpSettingId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "emailId.smtpSettingId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Email Content",
                                  "label-for": "email_content",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.selectedTemplate) + " "
                                ),
                                _c("validation-provider", {
                                  attrs: {
                                    rules: "required",
                                    name: "email content",
                                    vid: "Email Content",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("quill-editor", {
                                              model: {
                                                value:
                                                  _vm.selectedTemplate.body,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.selectedTemplate,
                                                    "body",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedTemplate.body",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "demo-inline-spacing" },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "D" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Save as Draft ")]
                              ),
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "A" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Send Now ")]
                              ),
                              _c(
                                "b-form-radio",
                                {
                                  attrs: { name: "radio1", value: "B" },
                                  model: {
                                    value: _vm.SelectedRadio,
                                    callback: function ($$v) {
                                      _vm.SelectedRadio = $$v
                                    },
                                    expression: "SelectedRadio",
                                  },
                                },
                                [_vm._v(" Schedule Sending ")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm.SelectedRadio === "B"
                          ? _c(
                              "b-col",
                              { staticClass: "mt-2", attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "date and time",
                                        vid: "dateNtim",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("h5", [
                                                  _vm._v("Date & Time"),
                                                ]),
                                                _c("b-form-datepicker", {
                                                  attrs: {
                                                    id: "form-control",
                                                    placeholder:
                                                      "Choose a date",
                                                    local: "en",
                                                    "initial-date": new Date(),
                                                  },
                                                  model: {
                                                    value: _vm.dateNtim,
                                                    callback: function ($$v) {
                                                      _vm.dateNtim = $$v
                                                    },
                                                    expression: "dateNtim",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c("b-col", { attrs: { md: "12" } }, [
                          _c(
                            "div",
                            { staticClass: "demo-inline-spacing" },
                            [
                              _vm.showSaveDraft
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "warning" },
                                      on: { click: _vm.saveDraft },
                                    },
                                    [_vm._v(" Save as Draft ")]
                                  )
                                : _vm._e(),
                              _vm.showSaveScheduled
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "info" },
                                      on: { click: _vm.saveScheduled },
                                    },
                                    [_vm._v(" Schedule ")]
                                  )
                                : _vm._e(),
                              _vm.showSendNow
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "ripple",
                                          rawName: "v-ripple.400",
                                          value: "rgba(255, 255, 255, 0.15)",
                                          expression:
                                            "'rgba(255, 255, 255, 0.15)'",
                                          modifiers: { 400: true },
                                        },
                                      ],
                                      attrs: { variant: "success" },
                                      on: { click: _vm.sendNow },
                                    },
                                    [_vm._v(" Send Now ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }